import { ref, shallowRef } from 'vue'

export function useFetch<T>() {
  const loading = ref(false)
  const error = ref()
  // Will not modify the inside of the object
  const data = shallowRef<T | null>(null)

  async function fetchData(requestMethod: () => Promise<T>) {
    loading.value = true
    try {
      const response = await requestMethod()
      data.value = response
      console.debug(data.value)
      loading.value = false
    }
    catch (err) {
      console.error(err)
      error.value = (err as any).message
    }
    finally {
      console.debug('fetchData finally')
      loading.value = false
    }
  }

  return {
    loading,
    error,
    data,
    fetchData,
  }
}
